'use client';
import React from 'react';
import * as Icon from '@/ui/Icon';
import * as Styled from './styled';

import { TagVariant } from '@/ui/Tag';

const badgeVariant: Record<string, TagVariant> = {
  added: 'success',
  removed: 'error',
  modified: 'info',
  default: 'default',
};

const badgeContent = {
  added: <Icon.Add />,
  removed: <Icon.Minus />,
  modified: <Icon.Dot width="75%" />,
  default: <span>?</span>,
};

const EntryStatusTag: React.FC<{ status: 'added' | 'modified' | 'removed' }> = ({ status }) => {
  return (
    <Styled.EntityStatusTag small variant={badgeVariant[status]} $status={status}>
      {badgeContent[status]}
    </Styled.EntityStatusTag>
  );
};

export default EntryStatusTag;
